import { render, staticRenderFns } from "./TabelaCadastrosVuetfy.vue?vue&type=template&id=0f6cfff9&scoped=true"
import script from "./TabelaCadastrosVuetfy.vue?vue&type=script&lang=js"
export * from "./TabelaCadastrosVuetfy.vue?vue&type=script&lang=js"
import style0 from "./TabelaCadastrosVuetfy.vue?vue&type=style&index=0&id=0f6cfff9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6cfff9",
  null
  
)

export default component.exports